import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useCustomerAuth } from "@/lib/customerAuth";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { LOGO_URL } from "@/lib/api";

export default function CustomerLogin() {
  const { login } = useCustomerAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const next = new URLSearchParams(location.search).get("next") || "/account";
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await login(email, password);
      toast.success("Welcome back");
      navigate(next);
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Login failed");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="max-w-md mx-auto px-5 py-10 sm:py-16" data-testid="customer-login-page">
      <div className="text-center mb-8 sm:mb-10">
        <img src={LOGO_URL} alt="" className="h-14 w-14 mx-auto mb-4 object-contain" />
        <div className="label-eyebrow !text-[10px] sm:!text-xs mb-2">Welcome Back</div>
        <h1 className="font-display text-[1.9rem] sm:text-4xl text-ink">Sign in</h1>
        <p className="text-ink-soft text-sm mt-2">Track your orders and check out faster.</p>
      </div>
      <form onSubmit={submit} className="space-y-5">
        <div>
          <Label className="text-ink-soft text-xs uppercase tracking-widest">Email</Label>
          <Input type="email" inputMode="email" autoComplete="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1.5 h-12 bg-cream border-border-subtle" data-testid="customer-login-email" />
        </div>
        <div>
          <Label className="text-ink-soft text-xs uppercase tracking-widest">Password</Label>
          <Input type="password" autoComplete="current-password" required value={password} onChange={(e) => setPassword(e.target.value)} className="mt-1.5 h-12 bg-cream border-border-subtle" data-testid="customer-login-password" />
        </div>
        <Button type="submit" disabled={submitting} className="w-full bg-sage hover:bg-sage-dark text-cream py-6 text-xs uppercase tracking-[0.22em] font-semibold transition-colors" data-testid="customer-login-submit">
          {submitting ? "Signing in…" : "Sign In"}
        </Button>
      </form>
      <div className="mt-6 text-center text-sm text-ink-soft">
        Don't have an account?{" "}
        <Link to="/register" className="text-sage hover:text-sage-dark font-semibold" data-testid="link-to-register">
          Create one
        </Link>
      </div>
    </div>
  );
}
